import styled from 'styled-components'

export const Content = styled.div`
    margin-left: 250px;
    padding: 1px 16px;

    form {
        display: flex;
        align-items: center;
        justify-content: space-around;
        flex-direction: row;
        gap: 20px;

        background: #f8f8f8;
        border-radius: 10px;
        padding: 20px;
        margin-top: 10px;
        margin-bottom: 10px;

        .label-avatar {
            width: 280px;
            height: 280px;

            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            cursor: pointer;

            span {
                z-index: 99;
                position: absolute;
                opacity: 0.7;
                transition: all 0.5s;

                &:hover {
                    opacity: 1;
                    transform: scale(1.4);
                }
            }

            input {
                display: none;
            }

            img {
                margin-bottom: 10px;
                border-radius: 50%;
                object-fit: cover;
            }
        }

        label {
            margin: 10px 0;
            font-size: 20px;

            input {
                margin-bottom: 10px;
            }
        }

        .box-inputs{
            display: flex;
            align-items: start;
            justify-content: start;
            flex-direction: column;
            width: 100%;

            input{
                padding: 8px;
                font-size: 15px;
                border: none;
                border-radius: 5px;
                width: 100%;
                background: #f1f3f5;

                &:disabled {
                    cursor: not-allowed;
                }
            }

            button {
                margin: 15px 0;
                max-width: 600px;
                background: #181c2e;
                color: #fff;
                border: none;
                border-radius: 5px;
                padding: 8px;
                font-size: 15px;
                width: 120px;
            }
        }
    }

    @media(max-width: 700px){
        margin-left: 0;
    }
`